import { IssueStatusType, ProcedureStepFieldValuesReviewType } from "@overmap-ai/common"

import { AssetMapColorMode, AssetTimelineItemType } from "./enums/assets"
import { FormSubmissionTimelineItemType } from "./enums/forms"
import { IssueTimelineItemType } from "./enums/issues"
import { ProcedureStepCompletionStatus } from "./enums/procedures"
import { ProjectTimelineItemTypeGroup } from "./enums/projects"
import type {
	AssetPdfExportOptions,
	FormSubmissionPdfExportOptions,
	IssuePdfExportOptions,
	ProcedurePdfExportOptions,
} from "./typings/reports"
import { Colors } from "./utils/colors"

export const emailRegex = /^.+@.+\..+$/

export const BREAKPOINTS = {
	xs: "0",
	sm: "768px",
	md: "1024px",
	lg: "1024px",
	xl: "1280px",
} as const

// Max length for title/name inputs, currently matches limit in backend
export const TITLE_MAX_LENGTH = 500

export const DEFAULT_COLOR = Colors.jade

export const PROJECT_NAME_FIELD_MAX_LENGTH = 50

// IMPORT ASSET CSV TEMPLATE
export const IMPORT_ASSET_CSV_TEMPLATE = "label,latitude,longitude\n"

export const DEFAULT_HIDDEN_ISSUE_STATUS_TYPES = [IssueStatusType.COMPLETED, IssueStatusType.CANCELLED]

export const PROCEDURE_STEP_COMPLETION_MODES = [
	AssetMapColorMode.LAST_COMPLETED_STEP,
	AssetMapColorMode.FIRST_INCOMPLETE_STEP,
]

export const PROCEDURE_STEP_COMPLETION_STATUSES = [
	ProcedureStepCompletionStatus.INCOMPLETE,
	ProcedureStepCompletionStatus.FAILED,
	ProcedureStepCompletionStatus.COMPLETE,
]

export const PROCEDURE_STEP_FIELD_VALUES_REVIEW_TYPES = [
	ProcedureStepFieldValuesReviewType.APPROVED,
	ProcedureStepFieldValuesReviewType.REJECTED,
	ProcedureStepFieldValuesReviewType.CHANGES_REQUESTED,
]

export const DEBUG = Boolean(import.meta.env.REACT_APP_DEBUG)

export const ASSET_TIMELINE_ITEM_TYPES = [
	AssetTimelineItemType.CREATED,
	AssetTimelineItemType.ATTACHMENT,
	AssetTimelineItemType.PROCEDURE,
	AssetTimelineItemType.FIELD_VALUES,
	AssetTimelineItemType.COMMENT,
	AssetTimelineItemType.ISSUE_ASSOCIATION,
	AssetTimelineItemType.IDENTIFIER_VALUE,
	AssetTimelineItemType.FORM_SUBMISSION,
]

export const ISSUE_ACTIVITY_HISTORY_ITEM_TYPES = [
	IssueTimelineItemType.CREATED,
	IssueTimelineItemType.ISSUE_UPDATE,
	IssueTimelineItemType.ISSUE_COMMENT,
	IssueTimelineItemType.ISSUE_ATTACHMENT,
	IssueTimelineItemType.ISSUE_ASSOCIATION,
	IssueTimelineItemType.FIELD_VALUES,
	IssueTimelineItemType.IDENTIFIER_VALUE,
	IssueTimelineItemType.FORM_SUBMISSION,
]

export const FORM_SUBMISSION_TIMELINE_ITEM_TYPES = [
	FormSubmissionTimelineItemType.CREATED,
	FormSubmissionTimelineItemType.COMMENT,
	FormSubmissionTimelineItemType.FIELD_VALUES,
	FormSubmissionTimelineItemType.IDENTIFIER_VALUE,
]

export const PROJECT_TIMELINE_ITEM_TYPE_GROUPS = [
	ProjectTimelineItemTypeGroup.ASSETS,
	ProjectTimelineItemTypeGroup.DOCUMENTS,
	ProjectTimelineItemTypeGroup.GEO_IMAGES,
	ProjectTimelineItemTypeGroup.ISSUES,
	ProjectTimelineItemTypeGroup.FORMS,
	ProjectTimelineItemTypeGroup.PROCEDURES,
	ProjectTimelineItemTypeGroup.COMMENTS,
	ProjectTimelineItemTypeGroup.ATTACHMENTS,
]

export const ASSET_PDF_EXPORT_OPTIONS: (keyof AssetPdfExportOptions)[] = [
	"asset_type_identifiers",
	"asset_type_fields",
	"procedures",
	"issue_associations",
	"form_submissions",
	"asset_attachments",
	"asset_comments",
]

export const FORM_SUBMISSION_PDF_EXPORT_OPTIONS: (keyof FormSubmissionPdfExportOptions)[] = [
	"form_identifiers",
	"form_fields",
	"form_submission_comments",
]

export const ISSUE_PDF_EXPORT_OPTIONS: (keyof IssuePdfExportOptions)[] = [
	"issue_type_identifiers",
	"issue_type_fields",
	"issue_associations",
	"form_submissions",
	"issue_attachments",
	"issue_comments",
]

export const PROCEDURE_PDF_EXPORT_OPTIONS: (keyof ProcedurePdfExportOptions)[] = [
	"procedure_steps",
	"procedure_type_fields",
]
